module.exports = __webpack_public_path__ + "img/gzhewm.4620c23b.jpg";